module.exports = "/_next/static/images/DefaultFlowersImageStore-9bff8dedeb5da9e81d3639696401aa94.webp";